import { defineMessages } from "react-intl";

const messages = defineMessages({
  editButton: {
    id: "settings.manageFields.bulkEditPane.button",
    defaultMessage: "Edit {count} {count, plural, one {field} other {fields}}",
    description: "Manage Fields - Bulk edit button title",
  },
  title: {
    id: "settings.manageFields.bulkEditPane.title",
    defaultMessage: "Edit {count} {count, plural, one {field} other {fields}}",
    description: "Manage Fields - title of Edit Field pane",
  },
});

export default messages;
